export const LEADERBOARD_LIST = "LEADERBOARD_LIST";
export const CREATE = "LEADERBOARD_CREATE";
export const SHOW_LEADERBOARD = "SHOW_LEADERBOARD";
export const SHOW_WINNER = "SHOW_WINNER";
export const DETAILS = "LEADERBOARD_DETAILS";
export const UPDATE = "LEADERBOARD_UPDATE";
export const DELETE = "LEADERBOARD_DELETE";
